import { toItem } from '../../mappers/itemMapper.js'

/** @typedef {import('../../mappers/itemMapper.js').RawItem} RawItem */
/** @typedef {import('../../mappers/itemMapper.js').Item} Item */

/**
 * @typedef {Object} Pagination
 * @property {number} currentPage
 * @property {number} totalPages
 * @property {number} totalCount
 */

/**
 * @param {{items: RawItem[], pagination: Pagination}} raw
 * @returns {{items: Item[], pagination: Pagination}}
 */
export const toSearchResult = raw => {
  return {
    items: raw.items.map(toItem),
    pagination: { ...raw.pagination }
  }
}

/**
 * @param {{attributes: {id: number, name: string}}[]} resources
 * @returns {{id: number, name: string}[]}
 */
export const toCategories = resources =>
  resources.map(({ attributes }) => ({
    id: attributes.id,
    name: attributes.name
  }))

/**
 * @param {{attributes: {id: number, name: string, description: string, image_url: string}}[]} resources
 * @returns {{id: number, name: string, description: string, imageUrl: string}[]}
 */
export const toScenes = resources =>
  resources.map(({ attributes }) => ({
    id: attributes.id,
    name: attributes.name,
    description: attributes.description,
    imageUrl: attributes.image_url
  }))

/**
 * @param {{attributes: {id: number, displayName: string}}[]} resources
 * @returns {{id: number, name: string}[]}
 */
export const toReceivingKinds = resources =>
  resources.map(({ attributes }) => ({
    id: attributes.id,
    name: attributes.displayName
  }))
